import type { CompassItem } from './BastionCompass';

export function collectAnchorIds(items: CompassItem[]): string[] {
  const ids: string[] = [];
  for (const item of items) {
    ids.push(item.id);
    if (item.children) {
      for (const child of item.children) ids.push(child.id);
    }
  }
  return ids;
}

/** Absolute scrollY that puts the section header under the sticky offset. */
export function getSectionScrollTop(id: string, headerOffset = 80): number | null {
  if (typeof document === 'undefined') return null;
  const el = document.getElementById(id);
  if (!el) return null;

  const bar = el.querySelector('.stock-section-bar') as HTMLElement | null;
  const target = bar && bar.offsetHeight > 0 ? bar : el;

  const elStyle = getComputedStyle(el);
  const scrollMargin = parseFloat(elStyle.scrollMarginTop) || 0;
  const offset = Math.max(headerOffset, scrollMargin);

  return target.getBoundingClientRect().top + window.scrollY - offset;
}

/** Same scroll target as BastionCompass section click. Returns false if anchor missing. */
export function scrollToSectionAnchor(
  id: string,
  headerOffset = 80,
  behavior: ScrollBehavior = 'smooth',
): boolean {
  const top = getSectionScrollTop(id, headerOffset);
  if (top == null) return false;
  window.scrollTo({ top, behavior });
  return true;
}
